import { schedulingUiEnabled } from '@/config/schedulingUi'
import { bookingUiEnabled } from '@/config/bookingUi'
import { ecomSettingsUiEnabled } from '@/config/ecomSettingsUi'
import { storeSettingsUiEnabled } from '@/config/storeSettingsUi'
import { devBuildUiEnabled } from '@/config/devBuildUi'

const formatEnvValue = (value) => {
  if (value === undefined || value === null || value === '') {
    return '—'
  }
  if (typeof value === 'boolean') {
    return value ? 'true' : 'false'
  }
  return String(value)
}

/**
 * Build-time runtime labels and feature flags baked into the bundle.
 * Shown in the Session Info debug panel; restart `quasar dev` after `.env` changes.
 */
export function getRuntimeEnvSnapshot () {
  return [
    { key: 'APP_VERSION', value: formatEnvValue(import.meta.env.APP_VERSION) },
    { key: 'APP_RUNTIME_ENV', value: formatEnvValue(import.meta.env.APP_RUNTIME_ENV) },
    { key: 'NODE_ENV', value: formatEnvValue(import.meta.env.NODE_ENV) },
    { key: 'QUASAR_DEV', value: formatEnvValue(import.meta.env.QUASAR_DEV) },
    { key: 'QUASAR_DEBUG', value: formatEnvValue(import.meta.env.QUASAR_DEBUG) },
    { key: 'API_URL', value: formatEnvValue(import.meta.env.API_URL) },
    { key: 'API_DOMAIN_SUFFIX', value: formatEnvValue(import.meta.env.API_DOMAIN_SUFFIX) },
    { key: 'API_RECOVERY_DOMAIN_SUFFIX', value: formatEnvValue(import.meta.env.API_RECOVERY_DOMAIN_SUFFIX) },
    { key: 'ENABLE_API_RECOVERY', value: formatEnvValue(import.meta.env.ENABLE_API_RECOVERY) },
    { key: 'SENTRY_ENVIRONMENT', value: formatEnvValue(import.meta.env.SENTRY_ENVIRONMENT) },
    { key: 'POS bootstrap', value: 'always on' },
    { key: 'Sentry cold start', value: 'tracing only (no replay/profiling at boot)' },
    { key: 'SCHEDULING_UI_ENABLED (active)', value: formatEnvValue(schedulingUiEnabled) },
    { key: 'BOOKING_UI_ENABLED (active)', value: formatEnvValue(bookingUiEnabled) },
    { key: 'ECOM_SETTINGS_UI_ENABLED (active)', value: formatEnvValue(ecomSettingsUiEnabled) },
    { key: 'STORE_SETTINGS_UI_ENABLED (active)', value: formatEnvValue(storeSettingsUiEnabled) },
    { key: 'DEV_BUILD_UI_ENABLED (active)', value: formatEnvValue(devBuildUiEnabled) }
  ]
}
